import React, { Component, Fragment } from 'react';
import { withRouter } from 'utils/common';
import {
  CALC_API_DEBOUNCE_DURATION,
  CANCELLATION_ERROR_MESSAGES,
  DATE_ERROR_MESSAGES,
  MAX_DURATION
} from '../../constants';
import i18n from 'utils/translate';
import Section from 'components/Section';
import TextField from 'components/TextField';
import InfoTextHeader from 'components/InfoTextHeader';
import NavigationButtons from 'components/NavigationButtons';
import Checkbox from 'components/Checkbox';
import { debounce } from 'underscore';
import { formatPrice } from 'utils/common';
import PropTypes from 'prop-types';
import { animateScroll } from 'react-scroll';
import ListItem from 'components/ListItem';
import RadioButtonGroup from 'components/RadioButtonGroup';
import Accordion from 'components/Accordion';
import AccordionItem from 'components/AccordionItem';
import moment from 'moment';
import { toast } from 'react-toastify';
import { TRAVEL_FILTERS } from 'utils/constants';
import ErrorMessage from 'components/ErrorMessage';
import { linkTypeShape } from 'utils/types';
import './styles.scss';

const propTypes = {
  calculateQuote: PropTypes.func.isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  backLink: PropTypes.shape(linkTypeShape),
  nextLink: PropTypes.shape(linkTypeShape).isRequired,
  onChange: PropTypes.func.isRequired,
  listItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string
    })
  ),
  vacation: PropTypes.shape({
    type: PropTypes.oneOf([TRAVEL_FILTERS.SINGLE, TRAVEL_FILTERS.FAMILY]),
    destination: PropTypes.oneOf([TRAVEL_FILTERS.INLAND, TRAVEL_FILTERS.FOREIGN]),
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    cancellation: PropTypes.bool,
    bookingDate: PropTypes.object
  })
};

const defaultProps = { onChange: console.log };

class TravelDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      infoAccept: false,
      submitted: false,
      type: TRAVEL_FILTERS.SINGLE,
      destination: TRAVEL_FILTERS.INLAND,
      startDate: null,
      endDate: null,
      cancellation: false,
      bookingDate: null,
      ...props.vacation,
      footerTop: 0,
      wrongStartDate: null,
      wrongEndDate: null
    };
  }

  componentDidMount() {
    this.calcQuote();
    animateScroll.scrollToTop({ duration: 0 });
  }

  handleReverse = e => {
    const {
      backLink: { go } = {
        go: () => {}
      }
    } = this.props;
    e.preventDefault();
    e.stopPropagation();
    go();
  };

  handleSubmit = () => {
    const {
      nextLink: { go } = {
        go: () => {}
      },
      onChange = () => {}
    } = this.props;
    const form = this.refs.form;

    if (form.checkValidity && !form.checkValidity()) {
      form.reportValidity();
      return;
    }

    onChange(this.state);
    go();

    window.dataLayer.push({
      event: 'onlineabschluss',
      formname: 'Reiseversicherung',
      action: 'Schritt 1 von 4'
    });
  };

  calcQuote() {
    const { type, destination, startDate, endDate } = this.state;

    if (!!type !== null && destination !== null && !!startDate && !!endDate) {
      this.requestQuote();
    }
  }

  requestQuote = debounce(() => {
    const { calculateQuote } = this.props;

    calculateQuote({
      ...this.state
    }).then(quote => {
      this.setState({ quote });
    });
  }, CALC_API_DEBOUNCE_DURATION);

  handleInfoAccept = ({ target: { checked: value } }) => {
    const { submitted } = this.state;

    this.setState({ infoAccept: value });
    if (submitted) {
      this.setState({ validForm: this.refs.form.checkValidity() });
    }
  };

  handleDataChange = (data, key) => {
    const { submitted } = this.state;
    const { onChange } = this.props;

    this.setState(
      {
        [`${key}`]: data
      },
      () => {
        this.calcQuote();
        onChange(this.state);
        if (submitted) {
          this.setState({ validForm: this.refs.form.checkValidity() });
        }
      }
    );
  };

  handleStartDateChange = (data, key) => {
    this.handleDataChange(data, key);
    this.checkBookingDateRelation(this.state.bookingDate, data);

    if (data) {
      let endDate = data.clone().add(1, 'day');
      endDate = moment(endDate.format('DD.MM.YYYY'), 'DD.MM.YYYY');

      this.handleDataChange(endDate, 'endDate');
      this.handleDataChange(null, 'wrongEndDate');
    }
  };

  resetBookingDate = () => {
    this.setState({
      bookingDate: null,
      bookingDateInfoMsg: '',
      blockingError: false,
      cancellationStartDate: null
    });
  };

  handleCancellationCheck = ({ target: { checked } }) => {
    this.handleDataChange(checked, 'cancellation');
    if (!checked) {
      this.resetBookingDate();
    }
  };

  checkBookingDateRelation = (bookingDate, startDate) => {
    let start;
    const { cancellation } = this.state;

    if (!startDate) {
      start = this.state.startDate;
    }

    this.handleDataChange(bookingDate, 'bookingDate');

    if (!cancellation) {
      this.resetBookingDate();
    } else if (bookingDate) {
      const durationToday = Math.floor(moment.duration(moment().diff(bookingDate)).asDays());
      let durationStartDate = Math.floor(moment.duration(moment().diff(start)).asDays());
      durationStartDate = durationStartDate < 0 ? durationStartDate * -1 : durationStartDate;

      if (durationToday > 0) {
        if (durationStartDate > MAX_DURATION) {
          const cancellationStartDate = moment().add(10, 'days').format('DD.MM.YYYY');
          this.setState({
            bookingDateInfoMsg: CANCELLATION_ERROR_MESSAGES.notToday,
            blockingError: false,
            cancellationStartDate
          });
        } else if (durationStartDate <= MAX_DURATION) {
          this.setState({
            bookingDateInfoMsg: CANCELLATION_ERROR_MESSAGES.lateCompletion,
            blockingError: true,
            cancellationStartDate: null
          });
        }
      } else {
        this.setState({
          bookingDateInfoMsg: null,
          blockingError: false,
          cancellationStartDate: null
        });
      }
    }
  };

  render() {
    const { backLink, listItems, vacation } = this.props;
    const {
      quote,
      infoAccept,
      type,
      destination,
      startDate,
      endDate,
      cancellation,
      bookingDate,
      submitted,
      downloadedBasicInfo,
      wrongStartDate,
      wrongEndDate,
      bookingDateInfoMsg,
      blockingError,
      cancellationStartDate
    } = this.state;
    const basicInfoDownloadClass = submitted && !downloadedBasicInfo ? 'download-error' : '';
    const basicInfoLink = window.documentLinks ? window.documentLinks.basicInfos : '';
    let finalPrice = null;
    let currency = null;

    // start date
    let startError = '';
    let minStartDate = moment().subtract(1, 'day');
    let maxStartDate = moment().add(1, 'year');

    if (moment.isMoment(wrongStartDate) && wrongStartDate.isValid()) {
      if (wrongStartDate.isBefore(moment())) {
        startError = DATE_ERROR_MESSAGES.inPast;
      } else if (wrongStartDate.isAfter(maxStartDate)) {
        startError = DATE_ERROR_MESSAGES.max365daysInFuture;
      }
    }

    // end date
    let endError = '';
    let maxEndDate = !!startDate ? startDate.clone().add(1, 'year') : moment().add(1, 'year');

    if (moment.isMoment(wrongEndDate) && wrongEndDate.isValid()) {
      if (wrongEndDate.isBefore(startDate)) {
        endError = DATE_ERROR_MESSAGES.beforeStart;
      } else if (wrongEndDate.isAfter(maxEndDate)) {
        endError = DATE_ERROR_MESSAGES.tooLong;
      }
    }

    // quote
    if (quote) {
      finalPrice = quote.price;
      currency = quote.currency;
    }

    return (
      <Fragment>
        <form
          ref="form"
          onSubmit={this.handleSubmit}
          className={`page-step-wrapper travel-details page-step-wrapper--narrow ${submitted ? 'submitted' : ''}`}
          id="insurance-form"
        >
          <Section header="Information zum Produktvertreiber">
            <InfoTextHeader checked={infoAccept} onChange={value => this.handleInfoAccept(value)} />
          </Section>

          <Section
            header="Variante"
            questionMark={i18n(
              'Die Familienversicherung gilt für maximal 2 Erwachsene und 5 minderjährige Personen, unabhängig vom Verwandtschaftsgrad. Ein gemeinsamer Wohnsitz ist nicht erforderlich.'
            )}
          >
            <div className="radio-button-group-wrapper">
              <RadioButtonGroup
                required={true}
                useGrid={true}
                id="type"
                value={type}
                onChange={data => this.handleDataChange(data, 'type')}
                options={[
                  {
                    label: i18n('Einzelversicherung'),
                    value: TRAVEL_FILTERS.SINGLE
                  },
                  {
                    label: i18n('Familienversicherung'),
                    value: TRAVEL_FILTERS.FAMILY
                  }
                ]}
              />
            </div>
          </Section>

          <Section header="Destination">
            <div className="radio-button-group-wrapper">
              <RadioButtonGroup
                required={true}
                useGrid={true}
                id="destination"
                value={destination}
                onChange={data => this.handleDataChange(data, 'destination')}
                options={[
                  {
                    label: i18n('Inland'),
                    value: TRAVEL_FILTERS.INLAND,
                    questionMark: i18n(
                      'Eine Inlandsreise findet in Österreich statt (siehe Punkt 1.2. der Allgemeinen Bedingungen für die Reiseversicherung).'
                    )
                  },
                  {
                    label: i18n('Ausland'),
                    value: TRAVEL_FILTERS.FOREIGN,
                    questionMark: i18n(
                      'Der Versicherungsschutz gilt weltweit, exkl. Iran, Nordkorea, der Krim, Syrien und Venezuela.'
                    )
                  }
                ]}
              />
            </div>
          </Section>

          <Section
            header="Reisezeitraum"
            questionMark={i18n(
              'Die Reiseversicherung muss vor Reiseantritt abgeschlossen werden! Der Versicherungszeitraum beträgt maximal 365 Tage.'
            )}
          >
            <TextField
              name="startDate"
              className="col-xs-12 col-md-4"
              required
              value={startDate}
              minDate={minStartDate}
              maxDate={maxStartDate}
              date
              placeholder={i18n('TT.MM.JJJJ')}
              onChange={data => this.handleStartDateChange(data, 'startDate')}
              onWrongDate={wrongStartDate => this.setState({ wrongStartDate })}
              customError={startError}
              ref="startDate"
            />
            <TextField
              name="endDate"
              className="col-xs-12 col-md-4"
              required
              value={endDate}
              minDate={startDate}
              maxDate={maxEndDate}
              date
              placeholder={i18n('TT.MM.JJJJ')}
              onChange={data => this.handleDataChange(data, 'endDate')}
              onWrongDate={wrongEndDate => this.setState({ wrongEndDate })}
              customError={endError}
              ref="endDate"
            />
          </Section>

          <Section header="Stornoschutz">
            <Checkbox
              className="col-xs-12"
              id="cancellation"
              name="cancellation"
              checked={cancellation}
              onChange={this.handleCancellationCheck}
              label={i18n('Inklusive Stornoschutz')}
            />

            {cancellation && (
              <div>
                <div className="row">
                  <TextField
                    name="bookingDate"
                    label={i18n('Buchungsdatum')}
                    className="col-xs-12 col-md-4"
                    value={bookingDate}
                    date
                    required
                    placeholder={i18n('TT.MM.JJJJ')}
                    onChange={data => this.checkBookingDateRelation(data)}
                    ref="date"
                  />
                </div>
                {bookingDateInfoMsg && (
                  <div className={`col-xs-12 booking-info ${blockingError ? 'booking-error' : 'booking-hint'}`}>
                    {i18n(bookingDateInfoMsg)}
                    {cancellationStartDate && <span>Stornoschutz ab {cancellationStartDate}</span>}
                  </div>
                )}
              </div>
            )}
          </Section>

          <div className="row">
            {startDate && endDate && (
              <div className="col-xs-12 hint">
                {i18n(
                  `Wir empfehlen Ihnen aufgrund Ihrer Angaben unsere Reiseversicherung GRAWE TRAVELSTAR ${
                    cancellation ? 'mit' : 'ohne'
                  } Stornoversicherung und einer Versicherungsdauer von ${startDate.format(
                    'DD.MM.YYYY'
                  )} bis ${endDate.format('DD.MM.YYYY')}.`
                )}
              </div>
            )}
          </div>

          <div className="row">
            <div className="bib-wrapper col-xs-12">
              <p>
                {i18n(
                  'Die standardisierten Produkt- bzw. Basisinformationsblätter beinhalten wichtige Informationen zur Reiseversicherung „GRAWE TRAVELSTAR“. Bitte nehmen Sie sich ausreichend Zeit und lesen Sie diese sorgfältig.'
                )}
              </p>
              <a
                className="col-xs-12 basicInfos-pdf"
                href={basicInfoLink}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => this.handleDataChange(true, 'downloadedBasicInfo')}
              >
                <span className="pdf-icon col-xs-2" />
                <span className={`col-xs-10 ${basicInfoDownloadClass}`}>
                  {i18n('Download der standardisierten Produkt- bzw. Basisinformationsblätter')}
                  <span className="field-error-message">
                    {i18n(
                      'Die standardisierten Produkt- bzw. Basisinformationsblätter sind verpflichtend herunterzuladen, wenn Sie überlegen, die Reiseversicherung „GRAWE TRAVELSTAR“ online abzuschließen.'
                    )}
                  </span>
                </span>
              </a>
              <p className="p-margin-top">
                {i18n(
                  'Sie können dieses Dokument sowie sämtliche vorvertragliche Informationen auch in Papierform erhalten.'
                )}
                <br />
                {i18n('Bitte senden Sie dazu ein Mail mit Ihrer Postanschrift an ')}
                <a href="mailto:reise.center.vs@grawe.at?subject=Postversand Vorvertragliche Informationen">
                  reise.center.vs@grawe.at
                </a>
                .
                <br />
                {i18n('Nach Erhalt der Dokumente können Sie mit dem Online-Vertragsabschluss fortfahren.')}
              </p>
            </div>
          </div>

          <div className="sticky-footer">
            <div className="page-step-wrapper__price">
              {i18n('Prämie (einmalig)')}&nbsp;
              {formatPrice(finalPrice, currency)}
            </div>

            <NavigationButtons
              nextLink={{
                go: () => {
                  this.setState({ submitted: true });

                  Object.keys(this.refs).forEach(key => {
                    if (this.refs[key].onBlur) {
                      this.refs[key].onBlur();
                    }
                  });

                  if (
                    finalPrice &&
                    currency &&
                    downloadedBasicInfo &&
                    this.refs.form.checkValidity &&
                    this.refs.form.checkValidity() &&
                    !blockingError
                  ) {
                    toast.dismiss();
                    this.handleSubmit();
                  } else {
                    toast.error(<ErrorMessage message={i18n('Bitte überprüfen Sie Ihre Angaben')} />);
                  }
                }
              }}
              backLink={backLink}
            />
          </div>
        </form>

        <Accordion className="mt-2">
          <AccordionItem header={i18n('Leistungsumfang im Detail')} id="insurance" defaultOpen={true}>
            <div className="list-wrapper">
              {listItems.map((item, i) => (
                <ListItem key={i} {...item} vacation={vacation} />
              ))}
            </div>{' '}
          </AccordionItem>
        </Accordion>
      </Fragment>
    );
  }
}

TravelDetails.defaultProps = defaultProps;
TravelDetails.propTypes = propTypes;

export default withRouter(TravelDetails);
